import { render, staticRenderFns } from "./CompetitionDetailsList.vue?vue&type=template&id=3fb2039f"
import script from "./CompetitionDetailsList.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports